import { useTranslation } from 'react-i18next';
import { LuCircleAlert, LuLightbulb } from 'react-icons/lu';

export default function SendFeedbackRootPanelContent({ onSelect }: { onSelect: (step: 'issue' | 'idea') => void }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-6 pt-3 text-center">
      {/* Image */}
      <div className="w-full h-48 flex justify-center items-center">
        <img
          src="/images/feedback.jpg"
          alt="Feedback"
          className="h-full object-contain"
          style={{ maxHeight: '100%' }}
        />
      </div>

      {/* Buttons */}
      <div className="w-full flex flex-col gap-2">
        <button
          onClick={() => onSelect('issue')}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-left hover:bg-muted transition-colors"
        >
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-indigo-100">
            <LuCircleAlert className="w-5 h-5 text-indigo-600" />
          </div>
          <span className="text-sm font-medium text-gray-900">{t('feedback.reportIssue')}</span>
        </button>

        <button
          onClick={() => onSelect('idea')}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-left hover:bg-muted transition-colors"
        >
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-indigo-100">
            <LuLightbulb className="w-5 h-5 text-indigo-600" />
          </div>
          <span className="text-sm font-medium text-gray-900">{t('feedback.suggestIdea')}</span>
        </button>
      </div>
    </div>
  );
}
